/* unplugin-vue-components disabled */import { render } from "./DashboardSocialTab.vue?vue&type=template&id=7888ef30&scoped=true&ts=true"
import script from "./DashboardSocialTab.vue?vue&type=script&lang=ts"
export * from "./DashboardSocialTab.vue?vue&type=script&lang=ts"

import "./DashboardSocialTab.vue?vue&type=style&index=0&id=7888ef30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7888ef30"]])

export default __exports__